import { ReportEntry } from '../../../../../../domain/report/ReportEntry';

export const reportRefSsLot2 = (reportEntry: ReportEntry): string =>
  reportEntry.refSsLot2 + ' : ' + reportEntry.ssLot2;
